/* eslint-disable no-underscore-dangle */
import PouchDB from 'pouchdb';
import { get } from '../utils/api';
import { upsert } from './common';
import endpoints from '../endpoints';

const TISCH_OFFENSIVES = 'XXSTischOffensives';

class TischOffensivesStore {
  constructor(name) {
    this.db = new PouchDB(name);
  }

  save = (response, onSuccess) => {
    upsert(this.db, TISCH_OFFENSIVES, response.data, onSuccess);
  };

  fetchAndSave = (onSuccess) => get(endpoints.salesPackages.get).then((response) => this.save(response, onSuccess));

  load = (callback) => {
    this.db
      .get(TISCH_OFFENSIVES)
      .then((doc) => {
        callback(doc);
      })
      .then(() => {})
      .catch(() => {
        callback();
      });
  };
}

export default TischOffensivesStore;
